import React, { FC, useEffect } from 'react';
import ProfileMenuHeader from '../ProfileMenuHeader';
import { Menu } from '../ProfileMenu';
import styles from './Favorites.module.scss';
import ProductCard from 'modules/shop/pages/ProductsByCategory/ProductCard';
import useIsAuth from 'sdk/hooks/useIsAuth';
import { useGetFavoriteProducts } from 'sdk/hooks/shop/useGetFavoriteProducts';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: any;
};

const Favorites: FC<Props> = ({ onClose }) => {
  const { data: isAuthData } = useIsAuth();
  const { data: favoriteProductsData, refetch } = useGetFavoriteProducts(isAuthData?.user?.id || '');
 const {t} = useTranslation() as any
  const handleClose = () => {
    onClose(Menu.PROFILE);
  };

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className={styles.favorites}>
      <ProfileMenuHeader text="Favorites" onClose={handleClose} />
      <div className={styles.favorites_count}>
        {favoriteProductsData?.count || 0} {t('products')}
      </div>
      <div className={styles.favorites_list}>
        {favoriteProductsData?.data?.map(product => (
          <ProductCard key={product.id} product={product.products} userId={isAuthData?.user?.id} />
        ))}
      </div>
    </div>
  );
};

export default Favorites;
